(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('integracao-parceiro', {
            parent: 'admin',
            url: '/integracao-parceiro',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'integracaoParceiro.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/integracao-parceiro/integracao-parceiro.html',
                    controller: 'IntegracaoParceiroController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('integracaoParceiro');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
